module.exports = {
  ADMIN_API_VERSION: '1.0.10',
  ADMIN_SDK_NAME: 'js-admin-sdk'
};